import React from 'react';
import PropTypes from 'prop-types';
import PreferencesSection from '../PreferencesSection';
import css from './SummaryEmailPreferences.scss';
import preferencesCss from '../PreferencesSection.scss';
import { getWord } from 'utils/tenant';
import { StaffNotificationPreferences } from 'utils/types';
import classnames from 'classnames';
import HourlyDropdown from 'common/HourlyDropdown';
import WeeklyDropdown from 'common/WeeklyDropdown';

const SummaryEmailPreferences = ({ notificationPreferences, setValue }) => {
    const getDailyOption = () => (
        <div className={classnames(css['summary-preference'], preferencesCss['profile-adv-options'])}>
            <span id="dailySummaryLabel">Daily at</span>
            <HourlyDropdown id="dailySummary"
                            ariaLabel="Daily digest at"
                            className={css['daily-time']}
                            isDisabled={!notificationPreferences.dailyNotification}
                            onChange={(hour) => setValue({ dailyNotificationTime: hour })}
                            value={notificationPreferences.dailyNotificationTime} />
        </div>
    );

    const getWeeklyOption = () => (
        <div className={classnames(css['summary-preference'], preferencesCss['profile-adv-options'])} id="weeklySummaryPreferences">
            <span id="weeklySummaryLabel">Weekly at</span>
            <HourlyDropdown id="weeklySummary"
                            ariaLabel="Weekly summary at"
                            className={css['weekly-time']}
                            isDisabled={!notificationPreferences.weeklyNotification}
                            onChange={(hour) => setValue({ weeklyNotificationTime: hour })}
                            value={notificationPreferences.weeklyNotificationTime} />
            <div className={css['week-day']}>
                <span>on</span>
                <WeeklyDropdown id="weeklySummaryWeek"
                                ariaLabel="Weekly summary on"
                                isDisabled={!notificationPreferences.weeklyNotification}
                                onChange={(day) => setValue({ weeklyNotificationDay: day })}
                                value={notificationPreferences.weeklyNotificationDay} />
            </div>
        </div>
    );

    return (
        <PreferencesSection isStaff
                            className={css['summary-email-preferences']}
                            headerText={'Summary Emails'}
                            descriptionText={'Set preferences for receiving summary emails.'}>
            <label id="summaryLabel">Send me a digest of all my Appointment and {getWord('tracker')} Item activity:</label>
            <div aria-labelledby="summaryLabel" data-role="controlgroup">
                <div className={css["no-summary"]}>
                    <input type="radio"
                           aria-label="Don't send me summary emails"
                           name="summaryEmails"
                           value="none"
                           onChange={() => setValue({ dailyNotification: false, weeklyNotification: false })}
                           checked={!notificationPreferences.weeklyNotification && !notificationPreferences.dailyNotification} />
                    Don&apos;t send me summary emails
                </div>
                <div className={css["daily-summary"]}>
                    <input type="radio"
                           aria-labelledby="dailySummaryLabel"
                           name="summaryEmails"
                           value="daily"
                           onChange={() => setValue({ dailyNotification: true, weeklyNotification: false })}
                           checked={notificationPreferences.dailyNotification} />
                    {getDailyOption()}
                </div>
                <div className={css["weekly-summary"]}>
                    <input type="radio"
                           aria-labelledby="weeklySummaryLabel"
                           name="summaryEmails"
                           value="weekly"
                           onChange={() => setValue({ dailyNotification: false, weeklyNotification: true })}
                           checked={notificationPreferences.weeklyNotification} />
                    {getWeeklyOption()}
                </div>
            </div>
        </PreferencesSection>
    );
};

SummaryEmailPreferences.propTypes = {
    notificationPreferences: StaffNotificationPreferences,
    setValue: PropTypes.func
};

export default SummaryEmailPreferences;
